module.exports = __webpack_public_path__ + "img/TZS09466.337e6597.jpeg";